const menu_items = [
   {
      name:'general.dashboard.title',
      link:'/',
      icon:'fa fa-tachometer',
      requiresPermissions: [
                           ]
   },
   {
      name:'general.companies.title',
      link:'/companies',
      icon:'fab fa-black-tie',
      requiresPermissions: [
                           'platform',
                           ]
   },
   {
      name:'general.users.title',
      link:'/users',
      icon:'fa fa-id-card',
      requiresPermissions: [
                           'platform',
                           ]
   },
   {
      name:'general.roles.title',
      link:'/users/roles',
      icon:'fa fa-user-plus',
      requiresPermissions: [
                           'platform',
                           ]
   },
   {
      name:'general.disciplines.title',
      link:'/disciplines',
      icon:'fa fa-list-ul',
      requiresPermissions: [
                           'platform',
                           ]
   },
   {
      name:'general.super_admin.billings.title',
      link:'/superadmin/billings',
      icon:'fa fa-usd',
      requiresPermissions: [
                           'platform',
                           ]
   },

];

export default menu_items;


// WEBPACK FOOTER //
// ./src/menu/role/platform_admin.js